module.exports = __webpack_public_path__ + "img/camera-button.73b5f03b.svg";